import { AuthSession } from '../model/app.model'

export namespace AppActions {
	export class SignIn {
		static readonly type = '[App] Sign in'

		constructor(public authSession: AuthSession) {}
	}

	export class SignOut {
		static readonly type = '[App] Sign out'
	}

	export class AuthRefresh {
		static readonly type = '[App] Auth refresh'

		constructor(public authSession: AuthSession) {}
	}

	export class SaveAuthReturnUrl {
		static readonly type = '[App] Save auth return url'

		constructor(public returnUrl: string) {}
	}
}
